import {useState} from 'react';
import Rating from 'react-rating';
import '../styles/FeedbackModal.css'; // CSS dosyasını içe aktarıyoruz

export default function FeedbackModal({isOpen, onClose, studentId, courseId, onFeedbackSubmitted}) {
    const [rating, setRating] = useState(0);
    const [comment, setComment] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);

    const handleSubmit = async () => {
        setIsSubmitting(true);
        try {
            const response = await fetch(`${process.env.REACT_APP_API_URL}/course-feedback/add-feedback`, {
                method: 'POST',
                headers: {'Content-Type': 'application/json'},
                body: JSON.stringify({
                    studentId,
                    courseId,
                    rating,
                    comment
                })
            });

            if (response.ok) {
                alert('🎉 Teşekkürler, geri bildiriminiz kaydedildi!');
                onFeedbackSubmitted();
                onClose();
            } else {
                alert('❗ Bir hata oluştu, lütfen tekrar deneyin.');
            }
        } catch (error) {
            console.error(error);
            alert('❗ Sunucu hatası oluştu.');
        } finally {
            setIsSubmitting(false);
        }
    };

    if (!isOpen) return null;

    return (
        <div className="feedback-modal-overlay">
            <div className="feedback-modal">
                <h2 className="feedback-modal-title">Kursu Değerlendir</h2>

                <div className="feedback-rating">
                    <Rating
                        initialRating={rating}
                        emptySymbol={<span style={{color: 'gray'}}>☆</span>}
                        fullSymbol={<span style={{color: 'orange'}}>★</span>}
                        onChange={setRating}
                        color="#f39c12"
                    />
                </div>

                <textarea
                    className="feedback-textarea"
                    placeholder="Yorumunuz (isteğe bağlı)"
                    value={comment}
                    onChange={(e) => setComment(e.target.value)}
                />
                <div className="feedback-buttons">
                    <button
                        className="feedback-cancel"
                        onClick={onClose}
                        disabled={isSubmitting}
                    >
                        İptal
                    </button>
                    <button
                        className="feedback-submit"
                        onClick={handleSubmit}
                        disabled={isSubmitting || rating === 0}
                    >
                        Gönder
                    </button>
                </div>
            </div>
        </div>
    );
}
